import { render, staticRenderFns } from "./WizardEnvironmentVars.vue?vue&type=template&id=5887725e"
import script from "./WizardEnvironmentVars.vue?vue&type=script&lang=js"
export * from "./WizardEnvironmentVars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports